import React from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import ErrorBoundary from 'components/Common/ErrorBoundary';
import usePopup from 'hooks/usePopup';
import { Option } from 'kingpin/atoms/ContextMenu';

import PeerGroupInfoPopup from './PeerGroupInfoPopup';

// The peer group info (PeerInfoButton) as a menu option, e.g. in a Studio
// block's menu. The menu hides rather than closes, so the popup stays open.
const PeerInfoOption = ({
  gadget,
}: {
  gadget: VisualisationDefinitions.GroupVsRemainder;
}) => {
  const { isOpen, open, close } = usePopup();

  return (
    <ErrorBoundary isHiddenError>
      <Option
        label="Peer group"
        icon="help"
        onClick={open}
        shouldHideInsteadOfCloseMenu
        testId="peer-group-info"
      />
      <ModalTransition>
        {isOpen && (
          <Modal
            onClose={close}
            shouldScrollInViewport={false}
            autoFocus={false}
          >
            <PeerGroupInfoPopup gadget={gadget} close={close} />
          </Modal>
        )}
      </ModalTransition>
    </ErrorBoundary>
  );
};

export default PeerInfoOption;
